// Call, WhatsApp and email links for a record, and the activity each one is logged as afterwards.
// Shared by the website and the app.
const digits = value => String(value || '').replace(/[^\d+]/g, '');

const telLink = value => (digits(value).replace(/\+/g, '').length >= 5 ? `tel:${digits(value)}` : '');
const whatsappLink = value => {
    const number = digits(value).replace(/^\+/, '');
    return number.length >= 8 ? `https://wa.me/${number}` : '';
};
const mailLink = value => {
    const text = String(value || '').trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(text) ? `mailto:${text}` : '';
};

// After someone calls, messages or emails from the CRM, they are asked to log it as this.
const LOG_PROMPTS = {
    call: { kind: 'Call', question: name => `Did you speak to ${name}?`, button: 'Log call' },
    whatsapp: { kind: 'WhatsApp message', question: name => `Did you message ${name} on WhatsApp?`, button: 'Log message' },
    email: { kind: 'Email', question: name => `Did you email ${name}?`, button: 'Log email' },
};
const LOG_PROMPT_HINT = 'Log it so the next person has the context.';

/** The Call / WhatsApp / Email links for a contact or a company, leaving out any it has no details for. */
function contactActions(type, record) {
    if (!record) return [];
    const phone = type === 'contacts' ? record.mobile || record.phone : record.phone;
    const actions = [
        { key: 'call', label: 'Call', href: telLink(phone) },
        ...(type === 'contacts' ? [
            { key: 'whatsapp', label: 'WhatsApp', href: whatsappLink(phone) },
            { key: 'email', label: 'Email', href: mailLink(record.email) },
        ] : []),
    ];
    return actions.filter(action => action.href);
}

module.exports = { telLink, whatsappLink, mailLink, LOG_PROMPTS, LOG_PROMPT_HINT, contactActions };
